import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'
import Thumb from 'components/Thumb/Thumb'
import { INFORMACION_PUBLICA_GRUPOS } from 'utils/constants'
import { getFileData } from 'utils/general'

function EditarInformacionPublica(props) {
	const { informacionOriginal, guardar, setQueMostrar } = props

	const [datos, setDatos] = useState({})
	const opcionesGrupo = INFORMACION_PUBLICA_GRUPOS

	useEffect(() => {
		setDatos({
			id: informacionOriginal.id,
			nombre: informacionOriginal.nombre,
			grupo: informacionOriginal.grupo,
			orden: informacionOriginal.orden,
			files: []
		})

	}, [informacionOriginal])

	const handleClose = () => {
		setQueMostrar('')
		setDatos({})
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datos,
		}

		guardar(data)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	const updateDocumento = (files) => {
		if (files.length > 0) {
			const datosCopia = { ...datos }
			datosCopia.files = files
			setDatos(prev => datosCopia)
		} else {
			const datosCopia = { ...datos }
			datosCopia.files = []
			setDatos(prev => datosCopia)
		}
	}

	const fileData = getFileData(informacionOriginal.documento?.url)

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Edición información pública" />
			<Offcanvas.Body>
				<h1>Datos de la información pública</h1>
				{datos.id && (
					<Row>
						<Col sm={12} md={6}>
							<Form onSubmit={handleProcesar} className="ms-4">
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="informacion-nombre">
											<FormLabel>Nombre</FormLabel>
											<Form.Control
												value={datos.nombre}
												type="text"
												onChange={(e) => handleChange(e.target.value, 'nombre')}
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="informacion-grupo">
											<Form.Select id="grupo" value={datos.grupo} onChange={(e) => handleChange(e.target.value, 'grupo')}>
												{opcionesGrupo.map((opcion) => (
													<option key={opcion} value={opcion}>
														{opcion}
													</option>
												))}
											</Form.Select>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<Form.Group className="mb-3 col-md-3" controlId="informacion-orden">
											<FormLabel>Orden</FormLabel>
											<Form.Control
												value={datos.orden}
												type="number"
												onChange={(e) => handleChange(e.target.value, 'orden')}
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<div className="documento-actual">
											<h4>Documento seleccionado</h4>
											<i className={fileData.icono}></i> <a href={process.env.REACT_APP_API_URL + 'uploads/' + informacionOriginal.documento.url}>{fileData.nombre}</a>
											<hr className="mb-5" />
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<FileUpload
											updateFiles={updateDocumento}
											title="Seleccionar documento"
											accept=".pdf,.docx,.doc"
										/>
									</Col>
								</Row>
							</Form>
						</Col>
					</Row>
				)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarInformacionPublica